<template>
    <div>
        <div class="flex justify-between">
            <a class="flex items-center h-10 px-4" :class="item.class" :href="item.url || '#'">{{ item.name }}</a>
            <button @click="expanded = !expanded" class="px-4 text-white">
                <svg class="w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                    />
                </svg>
            </button>
        </div>
        <transition name="accordion">
            <div v-if="expanded">
                <MobileItem class="pl-8" v-for="child in item.children" :key="child.id" :item="child" />
            </div>
        </transition>
    </div>
</template>

<script>
import MobileItem from './MobileItem';
export default {
    components: { MobileItem },
    props: ['item'],
    data() {
        return {
            expanded: false
        };
    }
};
</script>

<style lang="scss"></style>
